import React from "react";
import {Box, Typography} from "@mui/material";

const Marquee = ({objects, sec}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                overflow: "hidden",
                whiteSpace: "nowrap",
            }}
        >
            {[1, 2, 3, 4, 5, 6].map(item => <Typography
                    component="div"
                    sx={{
                        display: "flex",
                        justifyContent: 'space-around',
                        flexShrink: 0,
                        animation: `marquee1 ${sec}s linear infinite`,
                        "@keyframes marquee1": {
                            "0%": {
                                transform: "translateX(0%)",
                            },
                            "100%": {
                                transform: "translateX(-100%)",
                            },
                        },
                    }}
                >
                    {objects}
                </Typography>
            )}
        </Box>
    );
};

export default Marquee;
